<template>
    <div class="wiper-container">
        <div :class="{'bg-mask':isShowBgMask}"></div>
        <div :class="{'mask':isShowMask}"></div>
        <div class="level-dialog" v-if="isLevel">
            <div class="text">抱歉，技师无权限参与活动</div>
            <div class="btn" @click="goHome">
                返回首页
            </div>
        </div>
        <div class="level-dialog" v-if="isClosed">
            <div class="text">抱歉，活动已经结束</div>
            <div class="btn" @click="goHome">
                返回首页
            </div>
        </div>
        <div v-if="isShowHome" class="showHome">
            <div class="homeBox">
                <!-- 步骤 -->
                <div class="steps"></div>
                <!-- 视频上传 -->
                <div class="video-onload">
                    <van-uploader :max-count="1" accept="video/*" :after-read="afterVideoRead" result-type="file"
                        v-if="!videoUri && (displayType === '1'|| (displayType === '4' && !videoFileUri)) ">
                        <img v-if="displayType === '5'" class="onload-v"
                            src="../../../assets/images/activity/wiperVideo/video-v.png" />
                        <img v-else class="onload-v" src="../../../assets/images/activity/wiperVideo/video-v.png" />
                    </van-uploader>
                    <van-uploader
                        v-if="(videoUri && (displayType === '1' || displayType === '4' )) || (!videoUri && displayType === '4' && videoFileUri) "
                        class="video-upload" :max-count="1" accept="video/*" :after-read="afterVideoRead">
                        <video class="video" :src="getVideo()" controls="controls"></video>
                        <div class="van-uploader__preview-delete video-delete" @click="handleDeleteVideo">
                            <i class="van-icon van-icon-cross van-uploader__preview-delete-icon"></i>
                        </div>
                    </van-uploader>
                    <div v-if="displayType === '3' || displayType === '2' ||displayType === '5'" class="video-upload">
                        <video class="video" :src="getVideo()" controls="controls"></video>
                    </div>
                </div>
                <!-- 截图上传 -->
                <div class="screenshots-onload">
                    <div class="screenshots-box">
                        <div class="douyin">
                            <van-uploader :max-count="1" :deletable="true" :after-read="workshopafterRead1"
                                v-if="!supportUri1 && (displayType === '1' || (displayType === '4' && !supportFileUri1)) ">
                                <img class="onload-s"
                                    src="../../../assets/images/activity/wiperVideo/jietu-onload.png" />
                            </van-uploader>
                            <van-uploader
                                v-if="(supportUri1 && (displayType === '1' || displayType === '4' )) || (!supportUri1 && displayType === '4' && supportFileUri1) "
                                class="images-upload" :max-count="1" :after-read="workshopafterRead1">
                                <img class="images" :src="getImageUrl1()" />
                                <div class="van-uploader__preview-delete photo-delete" @click="handleDeleteScreen1">
                                    <i class="van-icon van-icon-cross van-uploader__preview-delete-icon"></i>
                                </div>
                            </van-uploader>
                            <div v-if="displayType === '3' || displayType === '2' || displayType === '5'"
                                class="images-upload">
                                <img v-if="supportFileUri1 !== ''" class="images" :src="getImageUrl1()"
                                    @click="previewImage1()" />
                                <img v-else class="no-images"
                                    src="../../../assets/images/activity/wiperVideo/no-on.png" />
                            </div>
                        </div>
                        <div class="weixin">
                            <van-uploader :max-count="1" :deletable="true" :after-read="workshopafterRead2"
                                v-if="!supportUri2 && (displayType === '1' || (displayType === '4' && !supportFileUri2))">
                                <img class="onload-s"
                                    src="../../../assets/images/activity/wiperVideo/jietu-onload.png" />
                            </van-uploader>
                            <van-uploader
                                v-if="(supportUri2 && (displayType === '1' || displayType === '4' )) || (!supportUri2 && displayType === '4' &&supportFileUri2) "
                                class="images-upload" :max-count="1" :deletable="true" :after-read="workshopafterRead2">
                                <img class="images" :src="getImageUrl2()" />
                                <div class="van-uploader__preview-delete photo-delete" @click="handleDeleteScreen2">
                                    <i class="van-icon van-icon-cross van-uploader__preview-delete-icon"></i>
                                </div>
                            </van-uploader>
                            <div v-if="displayType === '3' || displayType === '2' || displayType === '5'"
                                class="images-upload">
                                <img v-if="supportFileUri2 !== ''" class="images" :src="getImageUrl2()"
                                    @click="previewImage2()" />
                                <img v-else class="no-images"
                                    src="../../../assets/images/activity/wiperVideo/no-on.png" />
                            </div>
                        </div>
                        <div class="kuaishou">
                            <van-uploader :max-count="1" :after-read="workshopafterRead3"
                                v-if="!supportUri3 && (displayType === '1'|| (displayType === '4' && !supportFileUri3) )">
                                <img class="onload-s"
                                    src="../../../assets/images/activity/wiperVideo/jietu-onload.png" />
                            </van-uploader>
                            <van-uploader
                                v-if="(supportUri3 && (displayType === '1' || displayType === '4' )) || (!supportUri3 && displayType === '4' && supportFileUri3) "
                                class="images-upload" :max-count="1" :deletable="true" :after-read="workshopafterRead3">
                                <img class="images" :src="getImageUrl3()" />
                                <div class="van-uploader__preview-delete photo-delete" @click="handleDeleteScreen3">
                                    <i class="van-icon van-icon-cross van-uploader__preview-delete-icon"></i>
                                </div>
                            </van-uploader>
                            <div v-if="displayType === '3' || displayType === '2' || displayType === '5'"
                                class="images-upload">
                                <img v-if="supportFileUri3 !== ''" class="images" :src="getImageUrl3()"
                                    @click="previewImage3()" />
                                <img v-else class="no-images"
                                    src="../../../assets/images/activity/wiperVideo/no-on.png" />
                            </div>
                        </div>
                    </div>
                    <div class="kudos-tip">
                        <div v-if="displayType === '1' || displayType === '4'"> ( 点赞总数为三个截图总和 )</div>
                    </div>
                    <div class="kudos-counts">
                        <div class="counts-title">点赞总数</div>
                        <div class="kudos-box" v-if="submitType ==='0' || displayType === '1' || displayType === '4'">
                            <van-form validate-trigger="onChange">
                                <van-field type="text" class="upload-input" placeholder="请输入总点赞数" style="margin-left"
                                    clearable maxLength="10" v-model="newUserInfo.supportCount" name="validator" />
                            </van-form>
                            <div v-if="displayType === '4'" class="upload-btn-again" @click="handleSubmit()">
                            </div>
                            <div v-if="displayType !== '4'" class="upload-btn" @click="handleSubmit()">
                            </div>
                        </div>
                        <div v-if="submitType ==='1' && (displayType === '2' || displayType === '3' || displayType === '5') "
                            class="kudos-box">
                            <div class="upload-counts"><span>{{wiperList.supportCount}}</span></div>
                        </div>

                    </div>
                </div>
                <!-- 审核不通过 -->
                <div class="audit-results4" v-if="displayType === '4'">
                    <div class="remark-list">{{wiperList.remark}}</div>
                </div>
                <div class="audit-results3" v-if="displayType === '3' && couponClient !== '1'">
                </div>
                <div class="audit-results500" v-if="displayType === '3' && couponClient === '1'">
                    <div class="pass-btn" @click="goMycard"></div>
                    <span class="pass-tips">（也可以通过"我的卡券"查看使用）</span>
                </div>
                <div class="audit-results2" v-if="displayType === '2'">
                </div>
                <div class="audit-results1" v-if="displayType === '1' ">
                </div>
                <div class="audit-results5" v-if="displayType === '5'">
                    <div class="remark-list">{{wiperList.remark}}</div>
                </div>
                <!-- 点赞排名 -->
                <div class="kudos-ranking">
                    <div class="no-kudoslist"
                        v-if="displayType === '3' && supportRankingList && supportRankingList.length == 0"></div>
                    <div class="first" v-if="supportRankingList && supportRankingList.length>0">
                        <span class="first-img"></span>
                        <span class="first-noc">{{supportRankingList[0].workshopName}}</span>
                        <!-- <span class="counts-kudos">{{supportRankingList[0].supportCount}}次</span> -->
                    </div>
                    <div class="second" v-if="supportRankingList && supportRankingList.length>1">
                        <span class="second-img"></span>
                        <span class="second-noc">{{supportRankingList[1].workshopName}}</span>
                        <!-- <span class="counts-kudos">{{supportRankingList[1].supportCount}}次</span> -->
                    </div>
                    <div class="third" v-if="supportRankingList && supportRankingList.length>2">
                        <span class="third-img"></span>
                        <span class="third-noc">{{supportRankingList[2].workshopName}}</span>
                        <!-- <span class="counts-kudos">{{supportRankingList[2].supportCount}}次</span> -->
                    </div>
                    <div class="four" v-if=" supportRankingList && supportRankingList.length>3">
                        <span class="four-img">4</span>
                        <span class="four-noc">{{supportRankingList[3].workshopName}}</span>
                        <!-- <span class="counts-kudos">{{supportRankingList[3].supportCount}}次</span> -->
                    </div>
                    <div class="five" v-if="supportRankingList && supportRankingList.length>4">
                        <span class="five-img">5</span>
                        <span class="five-noc">{{supportRankingList[4].workshopName}}</span>
                        <!-- <span class="counts-kudos">{{supportRankingList[4].supportCount}}次</span> -->
                    </div>
                    <div class="watch-more">
                        <div class="last-mount" v-if="displayType ==='3'  && !isFirstMonth && !activityTimeEnd"
                            @click="openLastRanking"></div>
                        <div class="watch-all" v-if="displayType ==='3'  && !activityTimeEnd" @click="openRankingList">
                        </div>
                        <div class="november" v-if="displayType ==='3'  && !isFirstMonth && activityTimeEnd"
                            @click="openLastRanking"></div>
                        <div class="december" v-if="displayType ==='3'  && activityTimeEnd" @click="openRankingList">
                        </div>
                        <!-- <div class="no-last" v-if="displayType !=='3'"></div> -->
                        <div class="no-watch" v-if="displayType !=='3'"></div>
                    </div>
                    <div class="ranking-mask" v-if="displayType !=='3'">
                        <div class="mask-title">
                            <div class="title-span">
                                <span>上传视频和截图参加活动</span>
                                <span>审核通过后可查看排名信息</span>
                            </div>
                        </div>
                    </div>

                </div>
                <!-- 礼品展示 -->
                <div class="gift-show">

                </div>
                <!-- 活动时间 -->
                <div class="activity-time">

                </div>
                <!-- 活动规则 -->
                <div class="activity-rules">
                </div>
                <!-- 二维码 -->
                <div class="qr-code">
                </div>
            </div>
        </div>
        <!-- 查看全部排行榜 -->
        <div class="ranking-list-dialog" v-if="isShowRankWiper ">
            <div class="ranking-list-items">
                <div class="item-top">
                    <div v-if="rankingList.length === 0" class="no-ranking"></div>
                    <van-list v-else v-model="loading" :finished="currentMonthFinished" offset="30" ref="vanOnload"
                        :immediate-check="false" @load="onLoad">
                        <van-cell class="item" v-for=" (item,index) in rankingList" :key="item.clientId">
                            <div v-if="index<3"
                                :class="{'top-one': index === 0,'top-two': index === 1,'top-three': index === 2}">
                            </div>
                            <div v-if="index>2" class="left-item">{{item.ranking}}</div>
                            <div class="center-item van-ellipsis">{{item.workshopName}}</div>
                            <!-- <div class="right-item ">{{item.supportCount}}次</div> -->
                        </van-cell>
                    </van-list>
                </div>

                <div class="line">

                    <p class="line-text">我的排名</p>

                </div>
                <div class="item-bottom">
                    <div class="item2">
                        <div class="center-tip" v-if="currRanking.supportCount ===  undefined "></div>
                        <div v-if="currRanking.ranking <= 3 "
                            :class="{'top-one': currRanking.ranking === '1','top-two': currRanking.ranking === '2','top-three': currRanking.ranking === '3'}">
                        </div>
                        <div v-if="currRanking.ranking > 3 " class="left">{{currRanking.ranking}}</div>
                        <div class="center van-ellipsis" v-if="  currRanking.supportCount !==  undefined ">
                            {{currRanking.workshopName}}</div>
                        <!-- <div class="right" v-if="  currRanking.supportCount !==  undefined ">
                            {{currRanking.supportCount}}次</div> -->
                    </div>
                </div>
            </div>
            <div class="ranking-list-close" @click="closeRanking">
                <img class="img" src="../../../assets/images/activity/wiperVideo/close.png" alt="">
            </div>
        </div>
        <!-- 查看上月排行榜 -->
        <div class="ranking-last-dialog" v-if="isShowLastRankWiper">
            <div class="ranking-list-items">
                <div class="item-top">
                    <div v-if="lastRankingList.length === 0" class="no-ranking"></div>
                    <van-list v-model="loading" :finished="lastMonthFinished" offset="30" ref="vanOnload"
                        :immediate-check="false" @load="onLastLoad">
                        <van-cell class="item" v-for=" (item,index) in lastRankingList" :key="item.clientId">
                            <div v-if="index<3"
                                :class="{'top-one': index === 0,'top-two': index === 1,'top-three': index === 2}">
                            </div>
                            <div v-if="index>2" class="left-item">{{item.ranking}}</div>
                            <div class="center-item van-ellipsis">{{item.workshopName}}</div>
                            <!-- <div class="right-item ">{{item.supportCount}}次</div> -->
                        </van-cell>
                    </van-list>
                </div>
                <div class="line">
                    <p class="line-text">我的排名</p>
                </div>
                <div class="item-bottom">
                    <div class="item2">
                        <div class="center-tip2" v-if="currLastRanking.supportCount ===  undefined"></div>
                        <div v-if="currLastRanking.ranking <= 3 "
                            :class="{'top-one': currLastRanking.ranking === '1','top-two': currLastRanking.ranking === '2','top-three': currLastRanking.ranking === '3'}">
                        </div>
                        <div v-if="currLastRanking.ranking > 3 " class="left">{{currLastRanking.ranking}}</div>
                        <div class="center van-ellipsis" v-if=" currLastRanking.supportCount !==  undefined ">
                            {{currLastRanking.workshopName}}</div>
                        <!-- <div class="right" v-if=" currLastRanking.supportCount !==  undefined ">
                            {{currLastRanking.supportCount}}次</div> -->
                    </div>
                </div>
            </div>
            <div class="ranking-list-close" @click="closeLastRanking">
                <img class="img" src="../../../assets/images/activity/wiperVideo/close.png" alt="">
            </div>
        </div>
    </div>

</template>

<script>
import activityApi from '@/api/activity'
import { commonUtils } from '@/utils/common'
import { ImagePreview } from 'vant'
import fileApi from '@/api/file'
export default {
    data() {
        return {
            isShowMask: false, // 展示蒙层
            isShowBgMask: false, // 展示蒙层
            isShowRankingMask: true,
            isShowRankWiper: false, // 展示实时排行榜
            isShowLastRankWiper: false, // 展示上月排行榜
            isShowHome: true, // 展示首页
            supportRankingList: [], // 展示前五排行榜
            rankingList: [], // 获取实时排行数据列表
            currRanking: {}, // 获取我的排行数据
            currLastRanking: {},
            selectType: 0,
            lastRankingList: [], // 获取上个月实时排行数据列表
            supportFileUri1: '', // 截图
            supportFileUri2: '',
            supportFileUri3: '',
            supportFileId1: '',
            supportFileId2: '',
            supportFileId3: '',
            videoFileId: '', // 视频
            videoFileUri: '',
            supportUri1: '',
            supportId2: '',
            supportUri2: '',
            supportId3: '',
            supportUri3: '',
            supportId1: '',
            videoUri: '',
            isUploading: false,
            videId: '',
            wiperList: {},
            supportCount: '', // 点赞数
            submitType: '0', // 是否提交
            displayType: '1',
            isFirstMonth: '1',
            activityTimeEnd: '1',
            couponClient: '1',
            clientId: '',
            isLogin: false,
            isLevel: false,
            isClosed: false,
            currentMonthPage: 1,
            lastMonthPage: 1,// 默认展示第一页
            loading: false,
            currentMonthFinished: false,
            lastMonthFinished: false,
            fileList: [],
            isOpen: false,
            newUserInfo: {
                supportCount: ''
            },
        }
    },
    created() {
        if (!localStorage.getItem('userInfo')) {
            console.log("未登录");
            this.$router.push({ name: 'login2', query: { pickStar: 1 } })
        } else {
            commonUtils.reportViewTrace()
            let level = JSON.parse(localStorage.getItem('userInfo')).clientInfo.clientUserDTO.userRole
            this.level = level
            if (this.level === '03') {
                this.isLevel = true
                this.isShowMask = true
            } else {
                this.isLevel = false
                this.getWiperList()
            }
        }

    },
    methods: {
        verifyPhone(val) {
            var reg = !/^(0+)|[^\d]+/g.test(val)
            return reg // 返回true或false
        },
        // 活动详情
        getWiperList() {
            activityApi.getActivitywiper().then(res => {
                if (res.data.resultCode === '0') {
                    let data = res.data.resultData
                    this.activityTimeEnd = data.activityTimeEnd
                    this.submitType = data.submitType
                    this.displayType = data.displayType
                    if (this.activityTimeEnd === '1' && (this.displayType === '1' || this.displayType === '4' || this.displayType === '2' || this.displayType === '5')) {
                        this.isClosed = true
                        this.isShowMask = true
                    }
                    this.supportFileUri1 = data.wiperVideoEnroll.supportFileUri1 || ''
                    this.supportFileId1 = data.wiperVideoEnroll.supportFileId1 || ''
                    this.supportFileUri2 = data.wiperVideoEnroll.supportFileUri2 || ''
                    this.supportFileId2 = data.wiperVideoEnroll.supportFileId2 || ''
                    this.supportFileUri3 = data.wiperVideoEnroll.supportFileUri3 || ''
                    this.supportFileId3 = data.wiperVideoEnroll.supportFileId3 || ''
                    this.videoFileUri = data.wiperVideoEnroll.videoFileUri || ''
                    this.videoFileId = data.wiperVideoEnroll.videoFileId || ''
                    this.wiperList = data.wiperVideoEnroll
                    this.supportRankingList = data.supportRankingList
                    this.isFirstMonth = data.isFirstMonth
                    this.couponClient = data.couponClient
                }

            })

        },
        // 全部排行
        getRanking() {
            this.currentMonthFinished = false
            this.currentMonthPage = 1
            let params = {
                page: 1,
                pageSize: 6,
                selectType: 0
            }
            activityApi.getWiperRanking(params).then(res => {
                if (res.data.resultCode === '0') {
                    this.rankingList = res.data.resultData.supportRankingList || []
                    this.currRanking = res.data.resultData.currRanking || {}
                    this.selectType = 0
                }
            })
        },
        // 上月排行
        getLastRanking() {
            this.lastMonthFinished = false
            this.lastMonthPage = 1
            let params = {
                page: 1,
                pageSize: 6,
                selectType: 1
            }
            activityApi.getWiperRanking(params).then(res => {
                if (res.data.resultCode === '0') {
                    this.lastRankingList = res.data.resultData.supportRankingList || []
                    this.currLastRanking = res.data.resultData.currRanking || {}
                    this.selectType = 1
                }
            })
        },

        // 视频上传
        afterVideoRead(file, detail) {

            if (
                [
                    'video/mp4',
                    'video/ogg',
                    'video/flv',
                    'video/avi',
                    'video/wmv',
                    'video/rmvb',
                    'video/mov',
                    'video/quicktime',
                    'video/x-quicktime'
                ].indexOf(file.file.type) === -1
            ) {
                this.$toast('请上传正确的视频格式')
                this.handleDeleteVideo()
                return false
            }
            const isLt100M = file.file.size / 1024 / 1024 < 100
            if (!isLt100M) {
                this.$toast('上传视频大小不能超过100MB')
                this.handleDeleteVideo()
                return false
            }

            this.$toast.loading({
                duration: 0,
                message: '加载中...',
                forbidClick: true
            })
            fileApi.uploadFilePublic(file.file).then((response) => {
                this.$toast.clear()
                if (response.data.resultCode === '0') {
                    let fileDTO = response.data.resultData.fileDTO
                    this.videoId = fileDTO.fileId
                    this.videoUri = fileDTO.fileUri

                } else {
                    this.handleDeleteVideo()
                }
            })
                .catch((error) => {
                    console.log(error)
                    this.$toast.clear()
                    this.handleDeleteVideo()
                })
        },
        // 截图上传
        workshopafterRead1(file) {
            this.$toast.loading({
                duration: 0,
                message: '加载中...',
                forbidClick: true
            })
            fileApi.uploadFilePublic(file.file).then(response => {
                this.$toast.clear()
                if (response.data.resultCode === '0') {
                    this.supportId1 = response.data.resultData.fileDTO.fileId
                    this.supportUri1 = response.data.resultData.fileDTO.fileUri
                    file.status = ''
                    file.message = ''
                } else {
                    this.handleDeleteScreen1()
                }
            }).catch((error) => {
                console.log(error)
                this.$toast.clear()
                this.handleDeleteScreen1()
            })
        },
        workshopafterRead2(file) {
            this.$toast.loading({
                duration: 0,
                message: '加载中...',
                forbidClick: true
            })
            fileApi.uploadFilePublic(file.file).then(response => {
                this.$toast.clear()
                if (response.data.resultCode === '0') {
                    this.supportId2 = response.data.resultData.fileDTO.fileId
                    this.supportUri2 = response.data.resultData.fileDTO.fileUri
                } else {
                    this.handleDeleteScreen2()
                }
            }).catch((error) => {
                console.log(error)
                this.$toast.clear()
                this.handleDeleteScreen2()
            })
        },
        workshopafterRead3(file) {
            this.$toast.loading({
                duration: 0,
                message: '加载中...',
                forbidClick: true
            })
            fileApi.uploadFilePublic(file.file).then(response => {
                this.$toast.clear()
                if (response.data.resultCode === '0') {
                    this.supportId3 = response.data.resultData.fileDTO.fileId
                    this.supportUri3 = response.data.resultData.fileDTO.fileUri
                } else {
                    this.handleDeleteScreen3()
                }
            }).catch((error) => {
                console.log(error)
                this.$toast.clear()
                this.handleDeleteScreen3()
            })
        },
        // 获取视频
        getVideo() {
            if (this.submitType === '0' || (this.displayType === '4' && this.videoUri)) {
                return commonUtils.getImageUrl(this.videoUri)
            } else {
                return commonUtils.getImageUrl(this.videoFileUri)
            }
        },
        // 获取截图
        getImageUrl1() {
            if (this.submitType === '0' || (this.displayType === '4' && this.supportUri1)) {
                return commonUtils.getImageUrl(this.supportUri1)
            } else {
                return commonUtils.getImageUrl(this.supportFileUri1)
            }
        },
        getImageUrl2() {
            if (this.submitType === '0' || (this.displayType === '4' && this.supportUri2)) {
                return commonUtils.getImageUrl(this.supportUri2)
            } else {
                return commonUtils.getImageUrl(this.supportFileUri2)
            }
        },
        getImageUrl3() {
            if (this.submitType === '0' || (this.displayType === '4' && this.supportUri3)) {
                return commonUtils.getImageUrl(this.supportUri3)
            } else {
                return commonUtils.getImageUrl(this.supportFileUri3)
            }
        },
        // 图片预览
        previewImage1() {
            ImagePreview({
                images: [this.getImageUrl1()],
                startPosition: 0
            })
        },
        previewImage2() {
            ImagePreview({
                images: [this.getImageUrl2()],
                startPosition: 0
            })
        },
        previewImage3() {
            ImagePreview({
                images: [this.getImageUrl3()],
                startPosition: 0
            })
        },

        handleDeleteVideo() {
            this.videoUri = ''
            this.videoId = ''
            this.videoFileUri = ''
            this.videoFileId = ''
        },
        handleDeleteScreen1() {
            this.supportUri1 = ''
            this.supportId1 = ''
            this.supportFileId1 = ''
            this.supportFileUri1 = ''
        },
        handleDeleteScreen2() {
            this.supportUri2 = ''
            this.supportId2 = ''
            this.supportFileId2 = ''
            this.supportFileUri2 = ''
        },
        handleDeleteScreen3() {
            this.supportUri3 = ''
            this.supportId3 = ''
            this.supportFileId3 = ''
            this.supportFileUri3 = ''
        },
        // 提交视频按钮
        handleSubmit() {
            if (this.displayType === '4') {
                if (!this.supportUri1) {
                    this.supportUri1 = this.supportFileUri1;
                    this.supportId1 = this.supportFileId1;
                }
                if (!this.supportUri2) {
                    this.supportUri2 = this.supportFileUri2;
                    this.supportId2 = this.supportFileId2;
                }
                if (!this.supportUri3) {
                    this.supportUri3 = this.supportFileUri3;
                    this.supportId3 = this.supportFileId3;
                }
                if (!this.videoUri) {
                    this.videoUri = this.videoFileUri;
                    this.videoId = this.videoFileId;
                }
            }
            if (!this.videoUri && !this.videoId) {
                this.$toast.fail('请上传视频')
                return
            }
            if (!this.supportUri1 && !this.supportUri2 && !this.supportUri3) {
                this.$toast.fail('请上传截图')
                return
            }
            if (!this.newUserInfo.supportCount) {
                this.$toast.fail('请填写点赞数')
                return
            }
            if (!/^(0+)|[^\d]+/g.test(this.newUserInfo.supportCount) === false) {
                this.$toast.fail('请输入非零整数')
                return
            }
            const data = {
                videoFileId: this.videoId,
                videoFileUri: this.videoUri,
                supportFileUri1: this.supportUri1,
                supportFileUri2: this.supportUri2,
                supportFileUri3: this.supportUri3,
                supportFileId1: this.supportId1,
                supportFileId2: this.supportId2,
                supportFileId3: this.supportId3,
                supportCount: this.newUserInfo.supportCount
            }
            this.$toast.loading({
                message: '报名信息提交中...',
                forbidClick: true,
                loadingType: 'spinner',
                duration: 0
            })
            activityApi.wiperVideoEnroll(data)
                .then(response => {
                    this.$toast.clear()
                    if (response.data.resultCode === '0') {
                        this.resetInfo()
                        this.$dialog.alert({ message: '报名信息提交成功，请等待后台审核结果。' })
                            .then(() => {
                                this.getRanking()
                                this.getLastRanking()
                                this.getWiperList()
                            })
                    }
                })
                .catch(error => {
                    this.$toast.clear()
                    console.log(error)
                    this.$toast.fail('报名信息提交失败')
                })
        },
        // 重置参数
        resetInfo() {
            this.videoList = []
            this.videoFileId = ''
            this.videoFileUri = ''
            this.supportFileId1 = ''
            this.supportFileId2 = ''
            this.supportFileId3 = ''
            this.supportFileUri1 = '',
                this.supportFileUri2 = '',
                this.supportFileUri3 = '',
                this.newUserInfo = {
                    supportCount: ''
                }
        },

        // 底部刷新排名
        onLoad() {
            if (this.currentMonthFinished) {
                this.currentMonthPage = 0
            }
            let page = this.currentMonthPage + 1
            let params = {
                page: page,
                pageSize: 6,
                selectType: 0
            }
            activityApi.getWiperRanking(params).then(res => {
                if (res.data.resultCode === '0') {
                    let itemList = res.data.resultData.supportRankingList
                    this.rankingList = this.rankingList.concat(itemList)
                    this.loading = false
                    this.currentMonthPage++
                    if (res.data.resultData.supportRankingList < 6) {
                        this.currentMonthFinished = true

                    }
                }
            })
        },
        onLastLoad() {
            let page = this.lastMonthPage + 1
            let params = {
                page: page,
                pageSize: 6,
                selectType: 1
            }
            activityApi.getWiperRanking(params).then(res => {
                if (res.data.resultCode === '0') {
                    let itemList = res.data.resultData.supportRankingList
                    this.lastRankingList = this.lastRankingList.concat(itemList)
                    this.loading = false
                    this.lastMonthPage++
                    if (res.data.resultData.supportRankingList < 6) {
                        this.lastMonthFinished = true
                    }
                }
            })
        },
        // 打开全部排行榜
        openRankingList() {
            this.isShowHome = false
            this.isShowBgMask = true
            this.isShowRankWiper = true
            this.getRanking()

        },
        // 关闭全部排行榜
        closeRanking() {
            this.isShowHome = true
            this.isShowBgMask = false
            this.isShowRankWiper = false
        },
        // 打开上月排行榜
        openLastRanking() {
            this.isShowHome = false
            this.isShowBgMask = true
            this.isShowLastRankWiper = true
            this.getLastRanking()

        },
        // 关闭上月排行榜
        closeLastRanking() {
            this.isShowHome = true
            this.isShowBgMask = false
            this.isShowLastRankWiper = false
        },
        goHome() {
            this.$router.push({ name: 'home-main' })
        },
          // 去查看我的卡劵
    goMycard () {
      this.$router.push({ name: 'userCoupon' })
    },
    }

}
</script>

<style lang="less" scoped>
input:-moz-placeholder,
textarea:-moz-placeholder {
    color: #7ca0c1;

}

input:-ms-input-placeholder,
textarea:-ms-input-placeholder {
    color: #7ca0c1;

}

input::-webkit-input-placeholder,
textarea::-webkit-input-placeholder {
    color: #7ca0c1;

}

::v-deep .van-field__control {
    color: #d8dee3 !important;
}
@keyframes scaleDraw {  /*定义关键帧、scaleDrew是需要绑定到选择器的关键帧名称*/

0%{
transform: scale(1);  /*开始为原始大小*/
}

25%{
transform: scale(1.1); /*放大1.1倍*/
}

50%{
transform: scale(1);
}

75%{
transform: scale(1.1);
}
}

.mask {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, .7);
    z-index: 99;
}

.bg-mask {
    position: fixed;
    width: 100%;
    height: 810vh;
    top: 0;
    left: 0;
    background: url("https://jc-1300322797.cos.ap-shanghai.myqcloud.com/static/extra/img/activity/wiperVideo/ranking-bg.png") no-repeat;
    background-size: 100% auto;
    z-index: 3;
}

.wiper-container {
    position: relative;
    // height: 100%;
    width: 100%;
    box-sizing: border-box;

    .showHome {
        position: relative;
        background: url("../../../assets/images/activity/wiperVideo/wiper-background.png") no-repeat;
        background-size: 100% auto;
        width: 100%;
        height: 2530px;
        // height: 2530px;


        .homeBox {
            width: 100%;
            height: 100% -300px;
            position: absolute;
            top: 250px;

            .steps {
                margin: 0 auto;
                height: 60px;
                background: url("../../../assets/images/activity/wiperVideo/steps.png") no-repeat;
                background-size: 100% auto;
                width: 284px;
                margin-top: 15px;

            }


            // 视频上传
            .video-onload {
                width: 284px;
                height: 270px;
                margin: 0 auto;
                margin-top: 15px;
                z-index: 2;
                background: url("../../../assets/images/activity/wiperVideo/video-onload.png") no-repeat;
                background-size: 100% auto;



                .video-upload {
                    position: relative;
                    width: 284px;
                    height: 184px;

                    .video-delete {
                        position: absolute;
                        top: 62px;
                        right: 0px;
                        width: 20px;
                        height: 20px;
                        z-index: 8;
                        border-radius: 0 0 0 15px !important;

                        .van-uploader__preview-delete-icon {
                            font-size: 20px !important;
                        }
                    }

                    .video {
                        width: 200px;
                        height: 120px;
                        margin-left: 42px;
                        margin-top: 60px;
                    }
                }

                .onload-v {
                    margin-left: 42px;
                    margin-top: 60px;
                    width: 200px;
                    height: 120px;
                    background: url("https://jc-1300322797.cos.ap-shanghai.myqcloud.com/static/extra/img/activity/wiperVideo/video-v.png") no-repeat;
                    background-size: 100% auto;
                }
            }

            //截图上传
            .screenshots-onload {
                display: inline-block;
                margin-left: 47px;
                width: 284px;
                height: 384px;
                background: url("../../../assets/images/activity/wiperVideo/screenshots-onload.png") no-repeat;
                background-size: 100% auto;

                .screenshots-box {

                    display: flex;
                    width: 284px;
                    height: 97px;
                    justify-content: center;
                    margin-top: 65px;

                    .douyin {
                        height: 65.7px;
                        width: 60px;
                        display: flex;
                        align-items: center;
                        flex-direction: column;

                        .images-upload {
                            width: 60.8px;
                            height: 65.7px;

                            .photo-delete {
                                z-index: 8;
                                border-radius: 0 5px 0 15px !important;
                            }

                            .preview-cover {
                                position: absolute;
                                bottom: 0;
                                box-sizing: border-box;
                                width: 100%;
                                padding: 4px;
                                color: #fff;
                                font-size: 12px;
                                text-align: center;
                                background: rgba(0, 0, 0, 0.3);
                            }

                            .images {
                                width: 60.8px;
                                height: 65.7px;
                                border-radius: 5px;
                            }

                            .no-images {
                                width: 50.8px;
                                height: 18.7px;
                                background-size: 100% auto;
                                margin-top: 24px;
                                margin-left: 5px;
                            }
                        }

                        .onload-s {
                            width: 65.8px;
                            height: 69.7px;
                            // background: url("../../../assets/images/activity/wiperVideo/jietu-onload.png") no-repeat;
                            background-size: 100% auto;
                        }
                    }

                    .weixin {
                        width: 60px;
                        display: flex;
                        align-items: center;
                        flex-direction: column;
                        margin-left: 15px;
                        margin-right: 15px;

                        .images-upload {
                            width: 60.8px;
                            height: 65.7px;

                            .photo-delete {
                                z-index: 8;
                                border-radius: 0 5px 0 15px !important;
                            }

                            .images {
                                width: 60.8px;
                                height: 65.7px;
                                border-radius: 5px;
                            }

                            .no-images {
                                width: 50.8px;
                                height: 18.7px;
                                background-size: 100% auto;
                                margin-top: 24px;
                                margin-left: 5px;
                            }
                        }

                        .onload-s {
                            width: 65.8px;
                            height: 69.7px;
                            // background: url("../../../assets/images/activity/wiperVideo/jietu-onload.png") no-repeat;
                            background-size: 100% auto;
                        }
                    }

                    .kuaishou {
                        width: 60px;
                        display: flex;
                        align-items: center;
                        flex-direction: column;

                        .images-upload {
                            width: 60.8px;
                            height: 65.7px;

                            .photo-delete {
                                z-index: 8;
                                border-radius: 0 5px 0 15px !important;
                            }

                            .images {
                                width: 60.8px;
                                height: 65.7px;
                                border-radius: 5px;
                            }

                            .no-images {
                                width: 50.8px;
                                height: 18.7px;
                                background-size: 100% auto;
                                margin-top: 24px;
                                margin-left: 5px;
                            }
                        }

                        .onload-s {
                            width: 65.8px;
                            height: 69.7px;
                            // background: url("../../../assets/images/activity/wiperVideo/jietu-onload.png") no-repeat;
                            background-size: 100% auto;
                        }
                    }
                }

                .kudos-tip {
                    color: #ffffff;
                    font-size: 10px;
                    width: 284px;
                    text-align: center;
                    margin-top: 20px;
                }

                //点赞总数
                .kudos-counts {
                    display: flex;
                    width: 284px;
                    height: 94px;
                    justify-content: center;
                    flex-direction: column;

                    .counts-title {
                        font-size: 16px;
                        font-weight: 600;
                        color: #ffffff;
                        width: 284px;
                        height: 35px;
                        text-align: center;
                        line-height: 35px;
                    }


                    .kudos-box {
                        display: flex;
                        width: 284px;
                        height: 40px;
                        justify-content: center;



                        .upload-counts {
                            width: 150px;
                            height: 38px;
                            font-size: 20px;
                            margin-top: 10px;
                            font-weight: 800;
                            color: #ffffff;
                            text-align: center;
                            line-height: 38px;
                        }



                        .upload-input {
                            width: 150px;
                            // height: 38px;
                            background: url("https://jc-1300322797.cos.ap-shanghai.myqcloud.com/static/extra/img/activity/wiperVideo/upload-box.png") no-repeat;
                            background-size: 100% auto;
                            font-size: 10px;
                            border: none;
                            text-align: center;
                            line-height: 20px;
                            margin-left: 5px;
                            color: #d8dee3;
                        }


                        .upload-btn {
                            width: 61px;
                            height: 38px;
                            background: url("https://jc-1300322797.cos.ap-shanghai.myqcloud.com/static/extra/img/activity/wiperVideo/upload.png") no-repeat;
                            background-size: 100% auto;
                            cursor: pointer;
                        }

                        .upload-btn-again {
                            width: 61px;
                            height: 38px;
                            background: url("../../../assets/images/activity/wiperVideo/upload-btn-again.png") no-repeat;
                            background-size: 100% auto;
                            cursor: pointer;
                        }
                    }
                }
            }

            //审核不通过
            .audit-results4 {
                margin: 0 auto;
                width: 284px;
                height: 160px;
                margin-top: 10px;
                margin-bottom: 10px;
                background: url("../../../assets/images/activity/wiperVideo/no-pass12.png") no-repeat;
                background-size: 100% auto;

                .remark-list {
                    font-size: 14px;
                    color: #ffffff;
                    width: 100%;
                    height: 15px;
                    text-align: center;
                    line-height: 155px;
                }
            }

            .audit-results3 {
                margin: 0 auto;
                width: 284px;
                height: 150px;
                margin-top: 20px;
                background: url("https://jc-1300322797.cos.ap-shanghai.myqcloud.com/static/extra/img/activity/wiperVideo/displayTypee3.png") no-repeat;
                background-size: 100% auto;
            }

            .audit-results2 {
                margin: 0 auto;
                width: 284px;
                height: 150px;
                margin-top: 20px;
                background: url("https://jc-1300322797.cos.ap-shanghai.myqcloud.com/static/extra/img/activity/wiperVideo/displayTypee2.png") no-repeat;
                background-size: 100% auto;
            }

            .audit-results1 {
                margin: 0 auto;
                width: 284px;
                height: 150px;
                margin-top: 20px;
                background: url("https://jc-1300322797.cos.ap-shanghai.myqcloud.com/static/extra/img/activity/wiperVideo/displayTypee1.png") no-repeat;
                background-size: 100% auto;
            }

            .audit-results500 {
                margin: 0 auto;
                width: 284px;
                height: 170px;
                margin-top: 20px;
                background: url("../../../assets/images/activity/wiperVideo/pass500.png") no-repeat;
                background-size: 100% auto;
                position: relative;
                .pass-btn{
                    animation: scaleDraw 3s ease-in-out infinite;
                    width: 75px;
                    position: absolute;
                    top: 65%;
                    left: 36%;
                    height: 30px;
                background: url("../../../assets/images/activity/wiperVideo/pass-btn.png") no-repeat;
                background-size: 100% auto;
                }
                .pass-tips{
                    color: #efefef;
                    font-size: 7px;
                    display: block;
                    position: absolute;
                    top: 83%;
                    left: 30%;
                    height: 10px;
                }
            }

            .audit-results5 {
                margin: 0 auto;
                width: 284px;
                height: 160px;
                margin-top: 10px;
                margin-bottom: 10px;
                background: url("../../../assets/images/activity/wiperVideo/audit-pass.png") no-repeat;
                background-size: 100% auto;

                .remark-list {
                    font-size: 14px;
                    color: #ffffff;
                    width: 100%;
                    height: 15px;
                    text-align: center;
                    line-height: 155px;
                }
            }

            //点赞排名
            .kudos-ranking {
                display: inline-block;
                position: relative;
                margin-left: 47px;
                margin-top: 30px;
                margin-bottom: 10px;
                width: 284px;
                height: 284px;
                background: url("https://jc-1300322797.cos.ap-shanghai.myqcloud.com/static/extra/img/activity/wiperVideo/kudos-ranking.png") no-repeat;
                background-size: 100% auto;

                .no-kudoslist {
                    width: 100px;
                    height: 25px;
                    margin: 0 auto;
                    margin-top: 110px;
                    background: url("https://jc-1300322797.cos.ap-shanghai.myqcloud.com/static/extra/img/activity/wiperVideo/no-ranking.png") no-repeat;
                    background-size: 100% auto;
                }

                .first {
                    width: 284px;
                    display: flex;
                    overflow: hidden;
                    align-items: center;
                    justify-content: center;
                    margin-top: 40px;

                    .first-img {
                        width: 18px;
                        height: 23px;
                        background: url("https://jc-1300322797.cos.ap-shanghai.myqcloud.com/static/extra/img/activity/wiperVideo/one.png") no-repeat;
                        background-size: 100% auto;
                    }

                    .first-noc {
                        font-size: 10px;
                        color: #ffffff;
                        overflow: hidden;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                        width: 150px;
                        height: 23px;
                        margin-left: 20px;
                        line-height: 23px;
                    }

                    .counts-kudos {
                        color: #ffffff;
                        font-size: 10px;
                        width: 55px;
                        margin-left: 10px;

                    }
                }

                .second {
                    width: 284px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    margin-top: 10px;

                    .second-img {
                        width: 18px;
                        height: 23px;
                        background: url("https://jc-1300322797.cos.ap-shanghai.myqcloud.com/static/extra/img/activity/wiperVideo/two.png") no-repeat;
                        background-size: 100% auto;
                    }

                    .second-noc {
                        font-size: 10px;
                        color: #ffffff;
                        overflow: hidden;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                        width: 150px;
                        height: 23px;
                        margin-left: 20px;
                        line-height: 23px;

                    }

                    .counts-kudos {
                        color: #ffffff;
                        font-size: 10px;
                        width: 55px;
                        margin-left: 10px;

                    }
                }

                .third {
                    width: 284px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    margin-top: 10px;

                    .third-img {
                        width: 18px;
                        height: 23px;
                        background: url("https://jc-1300322797.cos.ap-shanghai.myqcloud.com/static/extra/img/activity/wiperVideo/three.png") no-repeat;
                        background-size: 100% auto;
                    }

                    .third-noc {
                        font-size: 10px;
                        color: #ffffff;
                        overflow: hidden;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                        width: 150px;
                        height: 23px;
                        margin-left: 20px;
                        line-height: 23px;
                    }

                    .counts-kudos {
                        color: #ffffff;
                        font-size: 10px;
                        width: 55px;
                        margin-left: 10px;

                    }
                }

                .four {
                    width: 284px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    margin-top: 10px;

                    .four-img {
                        width: 18px;
                        height: 23px;
                        color: #ffffff;
                        font-weight: 600;
                        line-height: 23px;
                        text-align: center;
                    }

                    .four-noc {
                        font-size: 10px;
                        color: #ffffff;
                        overflow: hidden;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                        width: 150px;
                        height: 23px;
                        margin-left: 20px;
                        line-height: 23px;
                    }

                    .counts-kudos {
                        color: #ffffff;
                        font-size: 10px;
                        width: 55px;
                        margin-left: 10px;

                    }
                }

                .five {
                    width: 284px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    margin-top: 10px;

                    .five-img {
                        width: 21px;
                        height: 26px;
                        color: #ffffff;
                        font-weight: 600;
                        line-height: 26px;
                        text-align: center;
                    }

                    .five-noc {
                        font-size: 10px;
                        color: #ffffff;
                        overflow: hidden;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                        width: 150px;
                        height: 23px;
                        margin-left: 20px;
                        line-height: 23px;
                    }

                    .counts-kudos {
                        color: #ffffff;
                        font-size: 10px;
                        width: 55px;
                        margin-left: 10px;

                    }
                }

                .ranking-mask {
                    position: absolute;
                    left: 25px;
                    top: 29px;
                    width: 233px;
                    height: 175px;
                    background: rgba(0, 0, 0, 0.082);
                    z-index: 3;

                    .mask-title {
                        width: 233px;
                        height: 175px;
                        z-index: 4;
                        color: #ffffff;

                        .title-span {
                            width: 233px;
                            height: 175px;
                            display: flex;
                            z-index: 4;
                            flex-direction: column;
                            justify-content: center;
                            align-items: center;

                            span {
                                margin-top: 10px;
                                z-index: 4;
                            }

                        }
                    }
                }

                .watch-more {
                    width: 100%;
                    position: absolute;
                    top: 220px;
                    display: flex;
                    align-items: center;
                    justify-content: space-around;
                    margin-top: 10px;

                    .watch-all {
                        width: 96px;
                        height: 33px;
                        background: url("https://jc-1300322797.cos.ap-shanghai.myqcloud.com/static/extra/img/activity/wiperVideo/watch-all.png") no-repeat;
                        background-size: 100% auto;
                    }

                    .no-watch {
                        width: 96px;
                        height: 33px;
                        background: url("https://jc-1300322797.cos.ap-shanghai.myqcloud.com/static/extra/img/activity/wiperVideo/no-watch.png") no-repeat;
                        background-size: 100% auto;
                    }

                    .last-mount {
                        width: 96px;
                        height: 33px;
                        background: url("https://jc-1300322797.cos.ap-shanghai.myqcloud.com/static/extra/img/activity/wiperVideo/last-mount.png") no-repeat;
                        background-size: 100% auto;
                    }

                    .november {
                        width: 96px;
                        height: 33px;
                        background: url("../../../assets/images/activity/wiperVideo/november.png") no-repeat;
                        background-size: 100% auto;
                    }

                    .december {
                        width: 96px;
                        height: 33px;
                        background: url("../../../assets/images/activity/wiperVideo/december.png") no-repeat;
                        background-size: 100% auto;
                    }

                    .no-last {
                        width: 96px;
                        height: 33px;
                        background: url("https://jc-1300322797.cos.ap-shanghai.myqcloud.com/static/extra/img/activity/wiperVideo/no-last.png") no-repeat;
                        background-size: 100% auto;
                    }
                }
            }

            //礼品展示
            .gift-show {
                margin: 10px auto;
                width: 284px;
                height: 295px;
                background: url("../../../assets/images/activity/wiperVideo/gift-show.png") no-repeat;
                background-size: 100% auto;
            }

            // 活动时间
            .activity-time {
                margin: 0 auto;
                width: 284px;
                height: 130px;
                background: url("https://jc-1300322797.cos.ap-shanghai.myqcloud.com/static/extra/img/activity/wiperVideo/activity-time.png") no-repeat;
                background-size: 100% auto;
            }

            // 活动规则
            .activity-rules {
                margin: auto;
                width: 284px;
                height: 420px;
                background: url("../../../assets/images/activity/wiperVideo/rules.png") no-repeat;
                background-size: 100% auto;
            }

            // 二维码
            .qr-code {
                margin: 0 auto;
                width: 84px;
                height: 84px;
                margin-top: 10px;
                background: url("https://jc-1300322797.cos.ap-shanghai.myqcloud.com/static/extra/img/activity/wiperVideo/qr-code.png") no-repeat;
                background-size: 100% auto;
            }
        }
    }

    // 打开全部排行榜
    .ranking-list-dialog {
        width: 330px;
        height: 491.7px;
        position: absolute;
        top: 100px;
        left: 24px;
        z-index: 9;
        background: url(https://jc-1300322797.cos.ap-shanghai.myqcloud.com/static/extra/img/activity/wiperVideo/all-ranking.png) no-repeat;
        background-size: 100% auto;

        .ranking-list-items {
            width: 277.7px;
            margin: 0 auto;
            margin-top: 60px;

            .item-top {
                width: 277.7px;
                height: 310px;
                // // color: #ffffff;
                overflow-y: scroll;

                .no-ranking {
                    width: 100px;
                    height: 30px;
                    margin: auto;
                    margin-top: 150px;
                    background: url(https://jc-1300322797.cos.ap-shanghai.myqcloud.com/static/extra/img/activity/wiperVideo/no-ranking.png) no-repeat;
                    background-size: 100% auto;
                }

                .item {
                    color: #faf9f9;
                    width: 277.7px;
                    height: 38px;
                    display: flex;
                    margin-top: 14px;
                    justify-content: space-around;
                    background-color: rgba(5, 46, 150, 0);

                    .van-cell__value--alone {
                        height: 31px;
                        display: flex;
                    }

                    .left-item {
                        text-align: center;
                        margin-right: 8px;
                        width: 55px;
                        line-height: 23px;
                        color: #fffefe;
                    }

                    .center-item {
                        width: 160px;
                        text-align: left;
                        font-size: 12px;
                        color: #fffefe;
                        line-height: 23px;

                    }

                    // .right-item {
                    //     width: 185px;
                    //     color: #fffefe;
                    //     line-height: 23px;
                    //     font-size: 12px;
                    // }
                }
            }

            .line {
                position: absolute;
                bottom: 80px;
                width: 277.7px;
                height: 39.3px;
                line-height: 39.3px;
                margin: 0 auto;
                display: flex;
                justify-content: center;
                font-size: 12px;
                color: rgb(225, 225, 225);



                .line-text {
                    color: #fffefe;
                    font-size: 18px;
                    font-weight: 600px;
                }
            }

            .item-bottom {
                .item2 {
                    color: #faf9f9;
                    width: 277.7px;
                    height: 23px;
                    display: flex;
                    margin-top: 60px;
                    margin-bottom: 30px;
                    justify-content: center;

                    .center-tip {
                        width: 140px;
                        height: 25px;
                        background: url(https://jc-1300322797.cos.ap-shanghai.myqcloud.com/static/extra/img/activity/wiperVideo/last-nojoin.png) no-repeat;
                        background-size: 100% auto;
                    }

                    .left {
                        text-align: center;
                        margin-right: 8px;
                        width: 40px;
                        line-height: 23px;
                        color: #fffefe;
                    }

                    .center {
                        width: 180px;
                        text-align: left;
                        font-size: 12px;
                        color: #fffefe;
                        line-height: 23px;
                        margin-left: 5px;

                    }

                    // .right {
                    //     width: 65px;
                    //     color: #fffefe;
                    //     line-height: 23px;
                    //     font-size: 12px;
                    // }
                }
            }
        }

        .ranking-list-close {
            height: 40px;
            margin-top: 70px;

            .img {
                width: 40px;
                height: 40px;
                margin-left: 143px;
            }
        }
    }

    // 打开上月排行榜
    .ranking-last-dialog {
        width: 330px;
        height: 491.7px;
        position: absolute;
        top: 100px;
        left: 24px;
        z-index: 9;
        background: url(https://jc-1300322797.cos.ap-shanghai.myqcloud.com/static/extra/img/activity/wiperVideo/last-ranking.png) no-repeat;
        background-size: 100% auto;

        .ranking-list-items {
            width: 277.7px;
            margin: 0 auto;
            margin-top: 60px;

            .item-top {
                width: 277.7px;
                height: 310px;
                // // color: #ffffff;
                overflow-y: scroll;

                .no-ranking {
                    width: 100px;
                    height: 30px;
                    margin: auto;
                    margin-top: 150px;
                    background: url(https://jc-1300322797.cos.ap-shanghai.myqcloud.com/static/extra/img/activity/wiperVideo/no-ranking.png) no-repeat;
                    background-size: 100% auto;
                }

                .item {
                    color: #faf9f9;
                    width: 277.7px;
                    height: 38px;
                    display: flex;
                    margin-top: 14px;
                    justify-content: space-around;
                    background-color: rgba(5, 46, 150, 0);

                    .van-cell__value--alone {
                        height: 31px;
                        display: flex;
                    }

                    .left-item {
                        text-align: center;
                        margin-right: 8px;
                        width: 55px;
                        line-height: 23px;
                        color: #fffefe;
                    }

                    .center-item {
                        width: 160px;
                        text-align: left;
                        font-size: 12px;
                        color: #fffefe;
                        line-height: 23px;

                    }

                    .right-item {
                        width: 65px;
                        color: #fffefe;
                        line-height: 23px;
                        font-size: 12px;
                    }
                }
            }

            .line {
                position: absolute;
                bottom: 80px;
                width: 277.7px;
                height: 39.3px;
                line-height: 39.3px;
                margin: 0 auto;
                display: flex;
                justify-content: center;
                font-size: 12px;
                color: rgb(225, 225, 225);



                .line-text {
                    color: #fffefe;
                    font-size: 18px;
                    font-weight: 600px;
                }
            }

            .item-bottom {
                .item2 {
                    color: #faf9f9;
                    width: 277.7px;
                    height: 23px;
                    display: flex;
                    margin-top: 60px;
                    margin-bottom: 30px;
                    justify-content: center;

                    .center-tip2 {
                        width: 110px;
                        background: url(https://jc-1300322797.cos.ap-shanghai.myqcloud.com/static/extra/img/activity/wiperVideo/no-join.png) no-repeat;
                        background-size: 100% auto;
                    }

                    .left {
                        margin-left: 8px;
                        width: 40px;
                        line-height: 23px;
                        color: #fffefe;
                    }

                    .center {
                        width: 185px;
                        text-align: left;
                        font-size: 12px;
                        color: #fffefe;
                        line-height: 23px;
                    }

                    // .right {
                    //     width: 65px;
                    //     color: #fffefe;
                    //     line-height: 23px;
                    //     font-size: 12px;
                    // }
                }
            }


        }

        .ranking-list-close {
            height: 40px;
            margin-top: 70px;

            .img {
                width: 40px;
                height: 40px;
                margin-left: 143px;
            }
        }
    }

    .level-dialog {
        width: 330px;
        height: 160px;
        position: absolute;
        top: 196px;
        left: 24px;
        z-index: 999;
        background-color: #ffffff;
        border-radius: 10px;
        text-align: center;

        .text {
            line-height: 100px;
            font-size: 18px;
            font-weight: 600;
        }

        .btn {
            width: 100px;
            height: 40px;
            line-height: 40px;
            margin: 0 auto;
            border-radius: 5px;
            color: #000000;
            // rgb(170, 219, 233)
            background-color: rgb(67, 77, 166);
            border: 1px solid rgb(40, 48, 114);
            color: #ffffff;

        }
    }

}

.top-one {
    width: 18px;
    height: 25px;
    margin-left: 20px;
    margin-right: 20px;
    background: url(https://jc-1300322797.cos.ap-shanghai.myqcloud.com/static/extra/img/activity/wiperVideo/one.png) no-repeat !important;
    background-size: 100% auto !important;
}

.top-two {
    width: 18px;
    height: 25px;
    margin-left: 20px;
    margin-right: 20px;
    background: url(https://jc-1300322797.cos.ap-shanghai.myqcloud.com/static/extra/img/activity/wiperVideo/two.png) no-repeat !important;
    background-size: 100% auto !important;
}

.top-three {
    width: 18px;
    height: 25px;
    margin-left: 20px;
    margin-right: 20px;
    background: url(https://jc-1300322797.cos.ap-shanghai.myqcloud.com/static/extra/img/activity/wiperVideo/three.png) no-repeat !important;
    background-size: 100% auto !important;
}

.top-onself {
    color: #cd1231 !important;
}
</style>
